import { render, staticRenderFns } from "./BlocMenu.vue?vue&type=template&id=49f2c77d&lang=pug&"
import script from "./BlocMenu.vue?vue&type=script&lang=js&"
export * from "./BlocMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlocMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f2c77d')) {
      api.createRecord('49f2c77d', component.options)
    } else {
      api.reload('49f2c77d', component.options)
    }
    module.hot.accept("./BlocMenu.vue?vue&type=template&id=49f2c77d&lang=pug&", function () {
      api.rerender('49f2c77d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/blocmenu/BlocMenu.vue"
export default component.exports